import React from 'react';

import classNames from 'classnames';

export interface IHeatProps {
    level: THeatLevel;
    className?: string;
    color?: 'blue';
    isActive?: boolean;
}

export type THeatLevel = 1 | 2 | 3 | 4 | 5 | 6;

const Heat = (props: IHeatProps): JSX.Element => {
    const className: string = classNames(
        'heat',
        {
            [`heat--color-${props.color}`]: !!props.color,
            'is-active': props.isActive,
        },
        `heat--level-${props.level}`,
        props.className,
    );

    return (
        <div className={className} />
    );
};

export default Heat;
